import React, { createContext, useContext, useState, useCallback } from 'react';
import { fetchData, postData, putData, deleteData } from '../../services/Api';
import { useAlert } from '../geral/AlertContext';
import { useMessage } from '../geral/MessageContext';
import { NotaItem } from '../../models/vendas/NotaItem';

const NotaItemContext = createContext();

export const useNotaItem = () => useContext(NotaItemContext);

export const NotaItemProvider = ({ children }) => {
    const [notaItens, setNotaItens] = useState([]);
    const { showAlert } = useAlert();
    const { showMessage } = useMessage();
    const [notaItemSel, setNotaItemSel] = useState(new NotaItem());

    const fetchNotaItens = useCallback(async (notaId) => {
        if (!notaId) return;
        try {
            const result = await fetchData('/NotaItem/GetByNotaId', { notaId });
            setNotaItens(result || []);
        } catch (error) {
            console.error("Erro ao buscar itens da nota:", error);
            showMessage(`Erro ao buscar itens da nota! ${error?.message || error}`, 'danger');
        }
    }, []);

    const addNotaItem = async (notaItem) => {
        try {
            const result = await postData('/NotaItem', notaItem);
            setNotaItens([...notaItens, result]);
            showAlert('Item da nota adicionado com sucesso!');
        } catch (error) {
            console.error("Erro ao adicionar item da nota:", error);
            showMessage('Erro ao adicionar item da nota!\n' + error, 'danger');
        }
    };

    const updateNotaItem = async (notaItem) => {
        try {
            const result = await putData('/NotaItem', notaItem);
            setNotaItens((notaItens) =>
                notaItens.map((ni) => (ni.id === result.id ? result : ni))
            );
            showAlert('Item da nota alterado com sucesso!');
        } catch (error) {
            console.error("Erro ao atualizar item da nota:", error);
            showAlert('Erro ao alterar item da nota!', 'danger');
        }
    };

    const deleteNotaItem = async (id) => {
        try {
            await deleteData('/NotaItem', { id });
            setNotaItens(notaItens.filter(ni => ni.id !== id));
            showAlert('Item da nota excluído com sucesso!');
        } catch (error) {
            console.error("Erro ao excluir item da nota:", error);
            showAlert('Erro ao excluir item da nota!', 'danger');
        }
    };

    return (
        <NotaItemContext.Provider value={{
            notaItens,
            setNotaItens,
            notaItemSel,
            setNotaItemSel,
            addNotaItem,
            updateNotaItem,
            deleteNotaItem,
            fetchNotaItens
        }}>
            {children}
        </NotaItemContext.Provider>
    );
};
